export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    //Initialize Slideshow Slides
    if($('.slideshow').length) {
      $('.slideshow').slick({
        dots: true,
        autoplay: true,
        fade: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
      });  
    }

    //Initialize Home Hero Slideshow
    if($('.hero-slideshow').length) {
      $('.hero-slideshow').slick({
        autoplay: true,
        fade: true,
        infinite: true,
        speed: 7000,
        arrows: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        swipe: false,
        touchMove: false,
      });  
    }

    //Initialize Choice Item Toggles for Choices CTA
    const choice_toggles = document.querySelectorAll('.choice-toggle');

    if(choice_toggles) {
      choice_toggles.forEach(function(choice_toggle) {
        choice_toggle.addEventListener('click', function() {
          //toggle class of button to rotate it
          this.classList.toggle('active');

          if(this.classList.contains('active')) {
            //need jquery for slideToggle
            let description = $(this).prev().find('.description');
            let description_inner = $(this).prev().find('.description-inner');
            //get height needed for description when toggling
            let description_height = description_inner.outerHeight() + 50;
            description.height(description_height);
          }
          else {
            let description = $(this).prev().find('.description');
            if(this.classList.contains('no-image')) {
              description.height(0);
            }
            else {
              description.height(100);
            }
          }
        });
      });
    }

    //Initialize states of selection button and accordion areas
    const choice_left = document.getElementById('choice-left');
    const choice_right = document.getElementById('choice-right');
    const choice_one = document.getElementById('choice-one');
    const choice_two = document.getElementById('choice-two');

    if(choice_left) {
      choice_left.addEventListener('click', function() {
        this.classList.add('active');
        choice_one.classList.add('active');
        choice_right.classList.remove('active');
        choice_two.classList.remove('active');
      });
    }

    if(choice_right) {
      choice_right.addEventListener('click', function() {
        this.classList.add('active');
        choice_two.classList.add('active');
        choice_left.classList.remove('active');
        choice_one.classList.remove('active');
      });
    }

    //Initialize Accordion
    const accordion_toggles = $('.toggle-accordion');

    if(accordion_toggles) {
      $(accordion_toggles).on('click', function() {
        let toggle_content = $(this).prev().find('.toggle-content');
        console.log(toggle_content)
        toggle_content.slideToggle();
        $(this).toggleClass('active');
      });
    }

    //Mobile Nav JS
    var $toggleButton = $('.toggle-button');
    // Hamburger button
    $toggleButton.on('click', function() {
      $(this).toggleClass('button-open');
      $('.menu-right-mobile').slideToggle();
    });

    //footer toggle menus
    // const footer_links = document.querySelectorAll('footer .column li.menu-item-has-children');

    // footer_links.forEach(function(footer_link) {
    //   //Create toggle arrows
    //   const toggle_arrow = document.createElement('img');
    //   toggle_arrow.setAttribute('src', '/wp-content/themes/LWC/dist/images/arrow_down.svg');
    //   toggle_arrow.classList.add('toggle-arrow-footer');
    //   footer_link.appendChild(toggle_arrow);
    // });
  
    //toggle submenu
    jQuery('.toggle-arrow-footer').click(function(){
      jQuery(this).toggleClass('active');
      const sub_menu = jQuery(this).prev('.sub-menu');
      sub_menu.slideToggle();
    });

    //header toggle menus
    const header_links = document.querySelectorAll('.menu-right-mobile li.menu-item-has-children');

    header_links.forEach(function(header_link) {
      //Create toggle arrows
      const toggle_arrow = document.createElement('img');
      toggle_arrow.setAttribute('src', '/wp-content/themes/LWC/dist/images/arrow_down.svg');
      toggle_arrow.classList.add('toggle-arrow-header');
      header_link.appendChild(toggle_arrow);
    });
  
    //toggle submenu
    jQuery('.toggle-arrow-header').click(function(){
      jQuery(this).toggleClass('active');
      const sub_menu = jQuery(this).prev('.sub-menu');
      sub_menu.slideToggle();
    });

    //Open Pureconnect links in new tab
    window.addEventListener('load', function () {
      const signup = document.querySelector('.sign-up');
      const forgot_password = document.querySelector('.forgot-password');
      signup.setAttribute('target', '_blank');
      forgot_password.setAttribute('target', '_blank');
    });

    var docWidth = document.documentElement.offsetWidth;

    [].forEach.call(
      document.querySelectorAll('*'),
      function(el) {
        if (el.offsetWidth > docWidth) {
          console.log(el);
        }
      }
    );

    //Replace frequently asked questions link with zendesk
    const links = document.querySelectorAll('[href*="frequently-asked-questions"]');
    links.forEach(function(link){
      link.href = 'https://louisvillewaterhelp.zendesk.com/hc/en-us';
      link.setAttribute('target', '_blank');
    });

    //click event for GTranslate custom button translte button
    const fire_gt_popup_button = document.getElementById('open-gt-popup');
    const gt_black_overlay = document.querySelector('.gt_black_overlay');
    const gt_white_content = document.querySelector('.gt_white_content');
    fire_gt_popup_button.addEventListener('click', function() {
      gt_black_overlay.style.display = 'block';
      gt_white_content.style.display = 'block';
      document.querySelectorAll('.gt_languages img:not([src])').forEach(function(img) {
        img.setAttribute('src', img.getAttribute('data-gt-lazy-src'));
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js